import { createReducer } from '../../../reducers/createReducer';
import { calcFilters } from '../../../helpers/listsHelper';

export const defaultFilters = [
  {
    column: 'transactionType',
    expression: 'equals',
    value: 'expenditure',
  },
  {
    column: 'transactionType',
    expression: 'exists',
    value: 'expenditure',
  },
  {
    column: 'missingPurpose',
    expression: 'customFilter',
    value: false,
  },
];

export const initialState = {
  timePeriod: 0,
  startDate: '',
  endDate: '',
  filters: [...defaultFilters],
  columns: [],
  columnDefinitions: [],
  errors: {
    startDate: '',
    endDate: '',
  },
};

export const actions = {
  HANDLE_CHANGE: 'HANDLE_CHANGE',
  SET_FORM_ERRORS: 'SET_FORM_ERRORS',
  SET_COLUMN_DEFINITIONS: 'SET_COLUMN_DEFINITIONS',
  HANDLE_MISSING_PURPOSE_CHECK: 'HANDLE_MISSING_PURPOSE_CHECK',
};

const calcFiltersWithDefaultFilters = calcFilters(defaultFilters);

export const actionMap = {
  [actions.HANDLE_CHANGE]: (state, { data: { fieldName, value } }) => {
    if (fieldName === 'timePeriod' && value !== 'custom') {
      return {
        ...state,
        [fieldName]: value,
        startDate: '',
        endDate: '',
        filters: calcFiltersWithDefaultFilters(fieldName, value, state),
      };
    }
    return {
      ...state,
      [fieldName]: value,
      filters: calcFiltersWithDefaultFilters(fieldName, value, state),
    };
  },
  [actions.HANDLE_MISSING_PURPOSE_CHECK]: (state, { data: { fieldName, value } }) => {
    return {
      ...state,
      [fieldName]: value,
      filters: calcFiltersWithDefaultFilters('missingPurpose', value, state),
    };
  },
  [actions.SET_FORM_ERRORS]: (state, { data: { errors } }) => ({
    ...state,
    errors,
  }),
  [actions.SET_COLUMN_DEFINITIONS]: (state, { data: columnDefinitions }) => ({
    ...state,
    columns: (columnDefinitions || []).map(cd => cd.key),
    columnDefinitions,
  }),
};

export const expendituresReducer = createReducer(
  initialState,
  actionMap,
);
